var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVCardCollectedCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_84_7809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.668 15.832C11.668 15.3737 11.293 14.9987 10.8346 14.9987H3.33464V9.9987H18.3346V4.9987C18.3346 4.08203 17.5846 3.33203 16.668 3.33203H3.33464C2.40964 3.33203 1.6763 4.0737 1.6763 4.9987L1.66797 14.9987C1.66797 15.9237 2.40964 16.6654 3.33464 16.6654H10.8346C11.293 16.6654 11.668 16.2904 11.668 15.832ZM16.668 6.66536H3.33464V4.9987H16.668V6.66536ZM16.668 18.332C16.2096 18.332 15.8346 17.957 15.8346 17.4987V15.832H14.168C13.7096 15.832 13.3346 15.457 13.3346 14.9987C13.3346 14.5404 13.7096 14.1654 14.168 14.1654H15.8346V12.4987C15.8346 12.0404 16.2096 11.6654 16.668 11.6654C17.1263 11.6654 17.5013 12.0404 17.5013 12.4987V14.1654H19.168C19.6263 14.1654 20.0013 14.5404 20.0013 14.9987C20.0013 15.457 19.6263 15.832 19.168 15.832H17.5013V17.4987C17.5013 17.957 17.1263 18.332 16.668 18.332Z",
    fill: "#5F488A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_84_7809"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVCardCollectedCard);
export default __webpack_public_path__ + "static/media/vCard_collectedCard.749c222f31d96b3fbda2f6cec33eea32.svg";
export { ForwardRef as ReactComponent };